import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

/** Europe/Moscow display for change history rows */
export function formatChangeHistoryDateTime(iso: string): { date: string; time: string } {
  const d = new Date(iso);
  return {
    date: format(d, 'dd.MM.yyyy', { locale: ru }),
    time: format(d, 'HH:mm', { locale: ru }),
  };
}

/** Bucket key for UI grouping: same user + same displayed minute → one card */
export function historyMinuteBucketKey(iso: string): string {
  const d = new Date(iso);
  return format(d, 'yyyy-MM-dd HH:mm', { locale: ru });
}
